import React from "react";
import Breadcrumb   from "../components/Breadcrumb/Breadcrumb";
import { FaInfoCircle } from "react-icons/fa";

const HotelProfileHeader = ({ hotelName, onEditClick }) => (
  <header className="hotel-profile-header">
    <Breadcrumb />
    <h1>{hotelName}</h1>
    <button className="info-button" onClick={onEditClick}>
      <FaInfoCircle /> Edit hotel info
    </button>
  </header>
);

export default HotelProfileHeader;
